import OptimizerEditDto from './OptimizerEditDto';

export class CobylaOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.rhobeg = null;
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.tol = null;
        /** @type {number} */
        this.catol = null;
    }

    /**
     * @typedef {Object} _CobylaOptimizerEditDtoProps
     * @property {number} rhobeg
     * @property {number} maxiter
     * @property {number} tol
     * @property {number} catol
     *
     * @typedef {import("./OptimizerEditDto").OptimizerEditDtoProps & _CobylaOptimizerEditDtoProps} CobylaOptimizerEditDtoProps
     */
    /**
     *
     * @param {CobylaOptimizerEditDtoProps} props
     * @returns {CobylaOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);
        this.rhobeg = props.rhobeg;
        this.maxiter = props.maxiter;
        this.tol = props.tol;
        this.catol = props.catol;
        return this;
    }
}

export default CobylaOptimizerEditDto;